const declinePopoverPrefix = 'decline-popover-';
const acceptDeclineBannerPrefix = 'accept-decline-banner-';
const acceptDeclineReasonTestIDs = {
  declineReasonTitle: declinePopoverPrefix + 'title',
  declineReasonType: declinePopoverPrefix + 'type-',
  declineReasonOtherReasonInput: declinePopoverPrefix + 'reason-other-input',
  declineReasonSave: declinePopoverPrefix + 'save-button',
  declineReasonCancel: declinePopoverPrefix + 'cancel-button',
  acceptDeclineBanner: acceptDeclineBannerPrefix + 'root',
  acceptDeclineBannerTitle: acceptDeclineBannerPrefix + 'title',
  acceptDeclineBannerAcceptBtn: acceptDeclineBannerPrefix + 'accept-button',
  acceptDeclineBannerDeclineBtn: acceptDeclineBannerPrefix + 'decline-button',
  acceptDeclineBannerDescription: acceptDeclineBannerPrefix + 'description',
};

export default acceptDeclineReasonTestIDs;
